import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ProductosService {

    constructor(private http: HttpClient) {}

    // Ahorros - Productos de crédito
    public getProductos(codigo: string, nombre: string): Observable<any[]> {
        return this.http.post('api/ahorros/catalogos/productos/get', {codigo: codigo, nombre: nombre}).pipe(
            map(res => JSON.parse(JSON.stringify(res)) )
        );
    }

}
